import { useCallback } from 'react';
import { DimensionValue } from 'react-native';

import { HORIZONTAL_ALERT_WIDTH, VERTICAL_ALERT_WIDTH } from '@components/alert/constants';
import { getActionColor, getActionFont, getAlertActions, getButtonBorder, getButtonRounding } from '@components/alert/helpers';
import { AlertAction, AlertActionStyle, AlertComponentProps, AlertPosition } from '@components/alert/types';
import { useAlertScaleFont } from './useAlertScaleFont';

export type UseManageAlertComponentParams = Pick<AlertComponentProps, 'C' | 'hide' | 'actions' | 'position' | 'boldPrimary'>;

export const useManageAlertComponent = ({ C, hide, actions, position, boldPrimary }: UseManageAlertComponentParams) => {
  const pos: AlertPosition = position || 'horizontal';
  const isHorizontal = pos === 'horizontal';
  const width = isHorizontal ? HORIZONTAL_ALERT_WIDTH : VERTICAL_ALERT_WIDTH;

  const { scale, font } = useAlertScaleFont();

  const conf: AlertAction[] = getAlertActions({ actions, hide });

  const getFont = useCallback((style?: AlertActionStyle) => getActionFont({ font, boldPrimary, style }), [font, boldPrimary]);

  const bntWidth: DimensionValue = isHorizontal ? `${100 / conf.length}%` : '100%';

  const btnBorder = getButtonBorder({ C, isHorizontal });

  const rounding = useCallback(
    (index: number): Record<string, number> => getButtonRounding({ index, isHorizontal, actionsCount: conf.length, scale }),
    [isHorizontal, scale, conf.length]
  );

  return {
    isHorizontal,
    width,
    scale,
    font,
    conf,
    getFont,
    getColor: getActionColor,
    bntWidth,
    btnBorder,
    rounding,
  };
};
